import React, { useContext } from 'react'
import { Typography } from 'antd'
import { Link } from 'react-router-dom';
import { appContext } from "../../AppContext";
import SubmitButton from './../../Utils/SubmitButton';
import InputField from './../../Utils/InputField';
import PasswordField from './../../Utils/PasswordField';
import { useTranslation } from 'react-i18next'

const { Text } = Typography;

export default function PasswordLogin({
    size: propsSize,
    isLoading: propsIsLoading,
    errorMessage: propsErrorMessage,
    isLoggingIn: propsIsLoggingIn
}) {

    const [appState] = useContext(appContext);
    const { t } = useTranslation(['login'])

    function getPasswordLink() {
        if (appState && appState.useEmail) {
            return <Link to={"forgot-password"}> {t("login.forgotPassword")} </Link>
        }
    }
    
    return (
        <>
            <InputField
                input="username"
                size={propsSize}
                label={t("login.username")}
                isRequired={true}
                isRequiredText={t("login.usernameRequired")}
                isLoading={propsIsLoading}
            />

            <PasswordField
                input="password"
                size={propsSize}
                label={t("login.password")}
                isRequired={true}
                isRequiredText={t("login.passwordRequired")}
                isLoading={propsIsLoading}
            />

            <SubmitButton
                isLoading={propsIsLoading}
                isDoingAction={propsIsLoggingIn}
                originalText={t("login.login")}
                loadingText={t("login.loading")}
                size={propsSize}
            />
            <Text type="danger">{propsErrorMessage}</Text>
            {propsErrorMessage && <br />}  
            {getPasswordLink()} 
        </>
    )
}